import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetEquipmentTypes } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  EquipmentTypeT,
  UseGetEquipmentTypesFilters,
} from "../../../../domain/entities";

const RenderOption = ({ description }: EquipmentTypeT): React.ReactElement => {
  return (
    <section className="grid grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>{description}</span>
    </section>
  );
};

const EquipmentTypeSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "description",
  keyword,
  multiselect,
}: SelectComponentProps<EquipmentTypeT>): React.ReactElement => {
  return (
    <Select<EquipmentTypeT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
    />
  );
};

export const EquipmentTypeSelect = withSelectOptions<
  EquipmentTypeT,
  UseGetEquipmentTypesFilters
>(EquipmentTypeSelectComponent, useInfiniteGetEquipmentTypes, "description");
